"use client";

import { createFileRoute } from "@tanstack/react-router";
import { categoriesQueryOptions } from "@/features/categories/hooks/use-categories";
import { ProductsContainer } from "@/features/products/layouts";
import { productsQueryOptions } from "@/features/products/hooks/use-products";
import { resolveStoreId } from "@/lib/store-loader";

export const Route = createFileRoute("/$store/_layout/products")({
	loader: async ({ context, params }) => {
		const storeId = await resolveStoreId(context.queryClient, params.store);
		if (!storeId) return;
		await Promise.all([
			context.queryClient.ensureQueryData(
				productsQueryOptions(params.store, storeId),
			),
			context.queryClient.ensureQueryData(
				categoriesQueryOptions(params.store, storeId),
			),
		]);
	},
	component: ProductsPage,
});

function ProductsPage() {
	return <ProductsContainer />;
}
